import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-x-0 bottom-0 z-[1020] flex flex-col bg-white",
  style: {"top":"100px"},
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "border-b border-gray-200" }
const _hoisted_3 = { class: "flex min-h-0 flex-1 flex-col overflow-y-auto bg-gray-50 p-6" }
const _hoisted_4 = { class: "mx-auto flex min-h-0 w-full max-w-7xl flex-1 flex-col" }

import { computed } from 'vue';
import FadeTransition from '@/components/transitions/FadeTransition.vue';
import type { ProductionGroup } from '@/types/ProductionGroup';
import ProductivityChart from './ProductivityChart.vue';
import SectionDetailHeader from './SectionDetailHeader.vue';
import type { SectionRow } from './sectionRow';


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionDetailOverlay',
  props: {
    section: {},
    sections: {},
    productionGroupHistory: {},
    productionGroupHistoryUnavailable: { type: Boolean }
  },
  emits: ["close", "navigate", "handleAlarm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const sectionId = computed(() => props.section?.id ?? null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(FadeTransition, null, {
      default: _withCtx(() => [
        (_ctx.section)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(SectionDetailHeader, {
                  section: _ctx.section,
                  sections: _ctx.sections,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
                  onNavigate: _cache[1] || (_cache[1] = ($event: any) => (emit('navigate', $event))),
                  onHandleAlarm: _cache[2] || (_cache[2] = ($event: any) => (emit('handleAlarm', $event)))
                }, null, 8, ["section", "sections"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(ProductivityChart, {
                    "section-id": sectionId.value,
                    "production-group-start": _ctx.section.productionGroupStart,
                    "production-group-history": _ctx.productionGroupHistory,
                    "production-group-history-unavailable": _ctx.productionGroupHistoryUnavailable
                  }, null, 8, ["section-id", "production-group-start", "production-group-history", "production-group-history-unavailable"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})